import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DatabaseProvider } from '../../providers/database';

interface HeartStatus {
  hearted: string | null;
}

@Component({
    imports: [CommonModule],
    selector: 'heart-button',
    templateUrl: 'heart-button.html',
    standalone: true
})
export class HeartButtonComponent implements OnInit {
  @Input() uid!: string;
  @Input() gig!: string;
  @Input() job!: string;
  @Input() ad!: string;
  @Input() vol!: string;

  status$: Observable<HeartStatus>;

  constructor(public db: DatabaseProvider) {
    this.status$ = new Observable<HeartStatus>();
  }

  ngOnInit() {
    if (this.gig) {
      this.status$ = this.db.gigSters(this.uid, this.gig) as Observable<HeartStatus>;
    } else if (this.job) {
      this.status$ = this.db.jobSters(this.uid, this.job) as Observable<HeartStatus>;
    } else if (this.ad) {
      this.status$ = this.db.adSters(this.uid, this.ad) as Observable<HeartStatus>;
    } else if (this.vol) {
      this.status$ = this.db.volSters(this.uid, this.vol) as Observable<HeartStatus>;
    }
  }

  createHeart() {
    if (this.gig) {
      this.db.createHeart(this.uid, this.gig);
    } else if (this.job) {
      this.db.createJobHeart(this.uid, this.job);
    } else if (this.ad) {
      this.db.createAdHeart(this.uid, this.ad);
    } else if (this.vol) {
      this.db.createVolHeart(this.uid, this.vol);
    }
  }

  removeHeart() {
    if (this.gig) {
      this.db.removeHeart(this.uid, this.gig);
    } else if (this.job) {
      this.db.removeJobHeart(this.uid, this.job);
    } else if (this.ad) {
      this.db.removeAdHeart(this.uid, this.ad);
    } else if (this.vol) {
      this.db.removeVolHeart(this.uid, this.vol);
    }
  }
}